import 'moment/locale/ja';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Tokyo');

export default moment;

export function utcMoment(...params: any) {
  return moment(...params).tz('UTC');
}

export function jstMoment(...params: any) {
  return moment(...params).tz('Asia/Tokyo');
}

export function formatDate(
  datetime?: string,
  formatMore2daysAgo: string = 'YYYY/MM/DD',
) {
  let mo;
  const now = jstMoment();
  if (datetime) {
    mo = jstMoment(datetime.replace(/\//g, '-').split(/ /)[0]);
  } else {
    mo = jstMoment();
  }

  if (now.format('YYYY/MM/DD') === mo.format('YYYY/MM/DD')) {
    return mo.format('今日 HH:mm');
  } else if (
    now.subtract(1, 'day').format('YYYY/MM/DD') === mo.format('YYYY/MM/DD')
  ) {
    return mo.format('昨日 HH:mm');
  } else {
    return mo.format(formatMore2daysAgo);
  }
}

export function formatOrderDate(datetime: string) {
  return jstMoment(datetime).format('YYYY/MM/DD HH:mm');
}

export function formatOrderDateCarousel(datetime: Date) {
  return jstMoment(datetime).format('YYYY年MM月DD日');
}

export function calcDiffDaysFromToday(datetime: string) {
  const today = jstMoment();
  const target = jstMoment(datetime);
  return today.diff(target, 'days');
}
